module.exports = __webpack_public_path__ + "img/insside-tycomm.5e2536e4.jpg";